<template lang="html">
  <div class="start-xs">
    <pl-dialog
      border-radius="5px"
      @close="close"
      :disableOutsideClick="true"
      :title="` ${optionalText}?`"
      :size="'lg'"
    >
      <div v-if="subHeader" class="my-3 px-7">
        <span> {{ subHeader }} </span>
      </div>
      <div class="remove-teachers flex-grow overflow-y-auto">
        <div
          v-if="teachersToRemove && teachersToRemove.length > 0"
          class="my-3 px-7"
        >
          <div class="mt-3" v-for="teacher in teachersToRemove">
            <span style="font-weight: 600"> {{ teacher.name }} </span>
            <div v-if="teacher.courses && teacher.courses.length > 0">
              <div class="flex w-full m-3" v-for="course in teacher.courses">
                <div class="w-1/3 truncate-text">
                  <span
                    >{{ course.title | truncate(15) }}
                    {{ course.sections[0] ? ' - ' + course.sections[0] : '' }}
                  </span>
                </div>
                <div
                  class="w-2/3 relative"
                  style="padding-right: 20px; position: relative"
                >
                  <multiselect
                    v-model="course.selected_teacher"
                    :options="course.teachers"
                    :multiple="false"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :selected="course.selected_teacher"
                    placeholder="Stay with teacher"
                    label="name"
                    track-by="id"
                    :limit="1"
                    :preselect-first="true"
                    ><template slot="singleLabel" slot-scope="{ option }">
                      {{ option.name }}
                    </template>
                  </multiselect>
                  <!-- <select v-model="course.selected_teacher">
                    <option
                      v-for="(teacher, index) in course.teachers"
                      :value="index"
                      :key="teacher.name + index"
                    >
                      {{ teacher.name }}
                    </option>
                  </select> -->
                </div>
              </div>
            </div>
            <div class="mt3" v-else>
              <span>This teacher doesn't have any course in the school.</span>
            </div>
          </div>
        </div>
      </div>
      <pl-input
        v-model="confirm"
        @keyup.native.enter="submitConfirm"
        :errorMessage="errorMessage"
        :labelText="labelText"
        class="mt3"
      />
      <div class="flex justify-center my-5">
        <button
          @click="close"
          class="px-7 py-2 mr-2 bg-gray-100 hover:bg-gray-200 rounded cursor-pointer text-gray-400 font-semibold"
        >
          CANCEL
        </button>
        <button
          @click="submitConfirm"
          class="px-8 py-2 bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold"
        >
          DELETE
        </button>
      </div>
    </pl-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import adminServices from 'services/admin/adminServices';

  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        confirm: '',
        errorMessage: '',
        course_list: [],
        course_teachers: [],
        selected_teacher: 'Stay with teacher',
        option_stay_with_teacher: 'Stay with teacher',
      };
    },
    props: {
      optionalText: {
        type: String,
        default: '',
      },
      labelText: {
        type: String,
        default: 'Please type in "confirm" to delete this item',
      },
      header: {
        type: String,
        default: 'Are you sure you want to delete this',
      },
      submitButton: {
        type: String,
        default: 'DELETE',
      },
      subHeader: {
        type: String,
        default: null,
      },
      teachersToRemove: {
        type: Array,
        default: null,
      },
    },
    computed: {
      ...mapGetters(['getCourses']),
    },
    methods: {
      submitConfirm() {
        if (this.confirm === 'confirm') {
          this.errorMessage = '';
          this.confirm = '';

          this.teachersToRemove.forEach((teacher) => {
            teacher.courses.forEach((course) => {
              const courseID = course.id;
              let teacher_id = '';
              if (course.selected_teacher !== null) {
                teacher_id = course.selected_teacher.id;
                if (teacher_id !== '') {
                  const payload = {
                    teacher_id,
                    deleted_teacher_id: teacher.id,
                  };
                  adminServices.updateCourseTeacherCoTeachers(
                    courseID,
                    payload
                  );
                } else {
                  adminServices.stayWithTeacher(courseID);
                }
              } else {
                adminServices.stayWithTeacher(courseID);
              }
            });
          });
          this.$emit('actionConfirmed');
          this.close();
        } else {
          this.errorMessage = 'Incorrect spelling. Please try again';
        }
      },

      updateCourseTeachers() {
        const payload = {
          teacher_id: this.selected_teacher.id,
          co_teachers_ids: [],
        };
        adminServices.updateCourseTeacherCoTeachers(this.courseID, payload);
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    .multiselect__content-wrapper {
      max-width: 100%;
    }
  }
  .multiselect {
    min-height: 2rem;
  }
  .multiselect .multiselect__content-wrapper {
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
  .multiselect .multiselect__clear {
    position: absolute;
    right: 2.5rem;
    height: 2rem;
    width: 2.5rem;
    display: block;
    cursor: pointer;
    z-index: 2;
  }

  .multiselect .multiselect__clear:after,
  .multiselect .multiselect__clear:before {
    content: '';
    display: block;
    position: absolute;
    width: 0.1875rem;
    height: 0.75rem;
    background: #aaa;
    top: 0.625rem;
    right: 0.25rem;
    cursor: pointer;
  }

  .multiselect .multiselect__clear:before {
    transform: rotate(45deg);
  }

  .multiselect .multiselect__clear:after {
    transform: rotate(-45deg);
  }

  .multiselect .multiselect__option {
    font-size: 0.875rem;
    padding: 0.375rem 0.5rem;
    min-height: 2rem;
  }

  .multiselect .multiselect__input,
  .multiselect .multiselect__single {
    background-color: transparent;
    font-size: 0.875rem !important;
    padding: 0;
    margin-bottom: 0.5rem;
  }

  .multiselect .multiselect__placeholder {
    padding-top: 0;
    margin-bottom: 0;
  }

  .multiselect .multiselect__select {
    height: 1.875rem;
  }

  .multiselect .multiselect__select:before {
    top: 1rem;
  }

  .multiselect .multiselect__tags {
    @apply bg-gray-50 border-0;
    min-height: 2rem;
    height: 2rem;
    padding-top: 0.375rem;
  }

  span.multiselect__option.multiselect__option--highlight:after {
    height: 1.875rem;
  }
</style>



// WEBPACK FOOTER //
// dialogDeleteTeachersConfirm.vue?16d35277